import React from "react";
import RJ_V1 from "./RJ_V1";

const RJ_DF_V1 = () => {

        return <RJ_V1 />;

    };

export default RJ_DF_V1;